/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Sleep_QualityInputs */

const en_us2_profile_editors_sleep_quality = /** @type {(inputs: Profile_Editors_Sleep_QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`And how well do you sleep?`)
};

const pt_br2_profile_editors_sleep_quality = /** @type {(inputs: Profile_Editors_Sleep_QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E a qualidade do sono?`)
};

const es_419_profile_editors_sleep_quality = /** @type {(inputs: Profile_Editors_Sleep_QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Y qué tan bien duermes?`)
};

const pt_pt2_profile_editors_sleep_quality = /** @type {(inputs: Profile_Editors_Sleep_QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E a qualidade do sono?`)
};

const fr_fr2_profile_editors_sleep_quality = /** @type {(inputs: Profile_Editors_Sleep_QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et la qualité de ton sommeil ?`)
};

const de_de2_profile_editors_sleep_quality = /** @type {(inputs: Profile_Editors_Sleep_QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Und wie gut schläfst du?`)
};

const it_it2_profile_editors_sleep_quality = /** @type {(inputs: Profile_Editors_Sleep_QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E quanto dormi bene?`)
};

/**
* | output |
* | --- |
* | "And how well do you sleep?" |
*
* @param {Profile_Editors_Sleep_QualityInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_sleep_quality = /** @type {((inputs?: Profile_Editors_Sleep_QualityInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Sleep_QualityInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_sleep_quality(inputs)
	if (locale === "es-419") return es_419_profile_editors_sleep_quality(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_sleep_quality(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_sleep_quality(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_sleep_quality(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_sleep_quality(inputs)
	return en_us2_profile_editors_sleep_quality(inputs)
});
export { profile_editors_sleep_quality as "profile-editors.sleep_quality" }